import get from "lodash/get";
import Taxes from "./taxes";

class Orderable {
  constructor(orderableObject, pricesObject) {
    this.orderableObject = orderableObject;
    this.pricesObject = pricesObject;
  }

  getPrices() {
    const zeroTotal = {amount: 0, currency: "usd"};
    return {
      subTotal: get(this.pricesObject, "data.attributes.sub_total", zeroTotal),
      discountTotal: get(this.pricesObject, "data.attributes.discount_total", zeroTotal),
      taxTotal: get(this.pricesObject, "data.attributes.tax_total", zeroTotal),
      shippingTotal: zeroTotal,
      creditCardFee: get(this.pricesObject, "data.attributes.credit_card_fee", null),
      totalPrice: get(this.pricesObject, "data.attributes.total", zeroTotal),
      deliveryFee: get(this.pricesObject, "data.attributes.delivery_fee", null),
    };
  }

  getDiscounts() {
    return get(this.pricesObject, "data.attributes.discounts", []);
  }

  getTaxDetails() {
    const taxDetailsObject = get(this.pricesObject, "data.attributes.taxes", null);
    return taxDetailsObject ? new Taxes(taxDetailsObject) : null;
  }

  hasDiscount() {
    const {discountTotal} = this.getPrices();
    return discountTotal.amount > 0;
  }
  getPromoCode() {
    return (
      get(this.orderableObject, "data.attributes.promo_codes.0") ||
      get(this.orderableObject, "data.attributes.promo_code", "")
    );
  }
  getPromoCodes() {
    const promoCode = get(this.orderableObject, "data.attributes.promo_code", "");
    const promoCodes = get(this.orderableObject, "data.attributes.promo_codes", []) || [];

    if (promoCode && promoCodes.length === 0) {
      return [promoCode];
    } else {
      return promoCodes;
    }
  }
  getReward() {
    return get(this.orderableObject, "data.attributes.reward_id", "");
  }
  getNotes() {
    return get(this.orderableObject, "data.attributes.notes", "");
  }
}

export default Orderable;
